// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .payment-forms_parent .compose-inscription-form__container{
 width: auto;
} */
.payment-forms_parent {
    margin: 50px 100px;
    background-color: white;
    padding: 20px;
}
.payment-forms_parent {
    margin: 50px 100px;
    background-color: white;
    padding: 20px;
}

.payment-forms_parent__stepper{
    margin-bottom: calc( var( --space-x3 ) + var( --space-half ) + var( --space-eighth));
    padding: 0 20px;
}

.payments-forms_parent-title {
    background-color: white;
    padding: 20px;
    display: flex;
}

button#payment-data__back-btn {
    border: none;
    margin-right: var( --space );
    color: var(--primary-very-dark-color);
    background-color: var(--white-color);
}

.payment-forms_parent__buttons{
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--space-x2);
    margin-top: var(--space-x2);
    padding-top: var(--space);
    border-top: solid 1px var(--new-input-background-color);
}

.payments__step-line__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

.payments__step-line__container .step-line {
    border-bottom: 2px solid var( --new-gray-disabled-color );
    height: 0;
    width: 100%;
    position: relative;
    top: -12px;
}

.payments__step-line__container .step-line:first-of-type {
    margin-left: 60px;
}

.payments__step-line__container .step-line:last-of-type {
    margin-right: var( --space-x3 );
}

.step-line.step-line-completed {
    border-bottom: 2px solid var( --new-green-color );
}

.payment-forms_parent .compose-inscription-form__container {
    padding: 12px 120px 30px 120px;
}


.payment-forms_parent_mobile_label{
    padding: 12px 120px 30px 120px;
}

.payment-forms_parent_mobile_label_subLabel{
    display: flex;
    flex-direction: column;
    gap: var(--space);
}

.payment-forms_parent_mobile_label_subLabel .baloa-table{
    font-weight: var(--font-medium);
}

.payment-forms_parent_mobile_label_subLabel .baloa-table-column{
    font-weight: var(--font-normal);
    color: var(--primary-very-dark-color);
}

.payment-forms__onboarding-submit-form {
    border: 3px solid var(--primary-very-light-color); 
    border-top: 3px solid var(--basic-green-color);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
    margin: auto;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .payment-forms_parent__stepper{
        margin-bottom: var(--space) !important;
    }

    .payment-forms_parent_mobile_label{
        margin: 20px 10px;
        padding: 0px;
    }

    .payment-forms_parent_mobile_label_subLabel .baloa-table {
        font-size: 16px;
    }

    .payment-forms_parent_mobile_label_subLabel .baloa-table-column {
        font-size: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/components/user-payments-form/UserPaymentsFormActiveComponent.styles.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oFAAoF;IACpF,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,yDAAyD;IACzD,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,iDAAiD;IACjD,8CAA8C;IAC9C,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;AAChB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,sCAAsC;IAC1C;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* .payment-forms_parent .compose-inscription-form__container{\n width: auto;\n} */\n.payment-forms_parent {\n    margin: 50px 100px;\n    background-color: white;\n    padding: 20px;\n}\n.payment-forms_parent {\n    margin: 50px 100px;\n    background-color: white;\n    padding: 20px;\n}\n\n.payment-forms_parent__stepper{\n    margin-bottom: calc( var( --space-x3 ) + var( --space-half ) + var( --space-eighth));\n    padding: 0 20px;\n}\n\n.payments-forms_parent-title {\n    background-color: white;\n    padding: 20px;\n    display: flex;\n}\n\nbutton#payment-data__back-btn {\n    border: none;\n    margin-right: var( --space );\n    color: var(--primary-very-dark-color);\n    background-color: var(--white-color);\n}\n\n.payment-forms_parent__buttons{\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: var(--space-x2);\n    margin-top: var(--space-x2);\n    padding-top: var(--space);\n    border-top: solid 1px var(--new-input-background-color);\n}\n\n.payments__step-line__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n}\n\n.payments__step-line__container .step-line {\n    border-bottom: 2px solid var( --new-gray-disabled-color );\n    height: 0;\n    width: 100%;\n    position: relative;\n    top: -12px;\n}\n\n.payments__step-line__container .step-line:first-of-type {\n    margin-left: 60px;\n}\n\n.payments__step-line__container .step-line:last-of-type {\n    margin-right: var( --space-x3 );\n}\n\n.step-line.step-line-completed {\n    border-bottom: 2px solid var( --new-green-color );\n}\n\n.payment-forms_parent .compose-inscription-form__container {\n    padding: 12px 120px 30px 120px;\n}\n\n\n.payment-forms_parent_mobile_label{\n    padding: 12px 120px 30px 120px;\n}\n\n.payment-forms_parent_mobile_label_subLabel{\n    display: flex;\n    flex-direction: column;\n    gap: var(--space);\n}\n\n.payment-forms_parent_mobile_label_subLabel .baloa-table{\n    font-weight: var(--font-medium);\n}\n\n.payment-forms_parent_mobile_label_subLabel .baloa-table-column{\n    font-weight: var(--font-normal);\n    color: var(--primary-very-dark-color);\n}\n\n.payment-forms__onboarding-submit-form {\n    border: 3px solid var(--primary-very-light-color); \n    border-top: 3px solid var(--basic-green-color);\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n    margin: auto;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .payment-forms_parent__stepper{\n        margin-bottom: var(--space) !important;\n    }\n\n    .payment-forms_parent_mobile_label{\n        margin: 20px 10px;\n        padding: 0px;\n    }\n\n    .payment-forms_parent_mobile_label_subLabel .baloa-table {\n        font-size: 16px;\n    }\n\n    .payment-forms_parent_mobile_label_subLabel .baloa-table-column {\n        font-size: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
